exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".social-nav {\n  white-space: nowrap; }\n  .social-nav a {\n    color: white;\n    font-size: 1.6em;\n    line-height: 1em;\n    margin: 0 5px;\n    drop-shadow: 0px 3px 10px rgba(0, 0, 0, 0); }\n    .social-nav a:hover {\n      transform: scale(1.05);\n      drop-shadow: 2px 10px 10px rgba(0, 0, 0, 0.25); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader!./src/ui/social-nav/social-nav.scss
// module id = 274
// module chunks = 0